import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { FilingStatusDialogData } from '../dialogs-data/filing-status-dialog-data';
import { FilingStatusDialogComponent } from '../dialogs/filing-status-dialog/filing-status-dialog.component';

@Injectable()
export class FilingStatusDialogService {
    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<FilingStatusDialogComponent>;

    open(filingStatusDialogData: FilingStatusDialogData) {
        console.log('FilingStatusDialogService.open called with data:', filingStatusDialogData);

        const matDialogConfig = new MatDialogConfig();

        matDialogConfig.panelClass = ['myapp-dialog', 'filing-status-dialog-panel'];
        matDialogConfig.width = '78%';
        matDialogConfig.maxWidth = '95vw';
        matDialogConfig.maxHeight = '90vh';
        matDialogConfig.data = filingStatusDialogData;
        matDialogConfig.disableClose = true;
        matDialogConfig.hasBackdrop = true;

        this.matDialogRef = this.dialog.open(FilingStatusDialogComponent, matDialogConfig);
    }

    confirmed(): Observable<any> {
        if (!this.matDialogRef) {
            return new Observable(observer => {
                observer.next(null);
                observer.complete();
            });
        }
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
